(function () {


  function fetchCartJson() {
    return fetch("/cart.js").then(function (res) {
      return res.json();
    });
  }

  function parseCartElement(html) {
    var wrapper = document.createElement("div");
    wrapper.innerHTML = html;
    return (
      wrapper.querySelector('cart-element[data-view="drawer"]') ||
      wrapper.querySelector("cart-element")
    );
  }

  function refreshRegionalFreeShipping() {
    if (!window.RegionalFreeShipping) return;

    window.RegionalFreeShipping.init();

    if (typeof window.RegionalFreeShipping.forceRender === "function") {
      window.RegionalFreeShipping.forceRender();
    }
  }

  function refreshDrawerTriggers() {
    var drawer = document.querySelector("drawer-element");

    if (drawer && typeof drawer.loadTriggers === "function") {
      drawer.loadTriggers();
      return;
    }

    var DrawerElement = customElements.get("drawer-element");

    if (DrawerElement && typeof DrawerElement.loadTriggers === "function") {
      DrawerElement.loadTriggers();
    }
  }

  function restoreCartPromoLabels() {
    document
      .querySelectorAll('.cart--item[data-cart-promo-label]')
      .forEach(function (itemEl) {
        var promoLabel = itemEl.getAttribute("data-cart-promo-label");
        if (!promoLabel) return;

        var discountEl = itemEl.querySelector(".cart--item--discount span");
        if (!discountEl) return;

        var text = (discountEl.textContent || "").trim();
        if (!text) return;

        if (text.toLowerCase().indexOf(promoLabel.toLowerCase()) === 0) return;

        var percentMatch = text.match(/^(\d+(?:[.,]\d+)?)\s*%/i);
        if (percentMatch) {
          discountEl.textContent = promoLabel + " " + text;
        }
      });
  }

  function refreshCartDrawerFromSections() {
    var root =
      (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";

    return fetch(root + "?sections=cart-drawer", {
      headers: {
        "Cache-Control": "no-cache",
      },
    })
      .then(function (response) {
        if (!response.ok) {
          throw new Error("Falha ao atualizar cart drawer");
        }

        return response
          .clone()
          .json()
          .catch(function () {
            return response.text();
          });
      })
      .then(function (payload) {
        var html =
          typeof payload === "string"
            ? payload
            : payload && payload["cart-drawer"];

        if (!html) return;

        var currentContainer = document.querySelector(
          '.drawer--container[data-view="cart-drawer"]'
        );
        var currentCart = document.querySelector('cart-element[data-view="drawer"]');
        var freshCart = parseCartElement(html);

        if (currentContainer && freshCart) {
          currentContainer.innerHTML = "";
          currentContainer.appendChild(freshCart);
        } else if (currentCart && freshCart) {
          currentCart.replaceWith(freshCart);
        }

        refreshDrawerTriggers();
        refreshRegionalFreeShipping();
        restoreCartPromoLabels();
      });
  }

  window.atualizarTotaisCarrinho = function () {
    fetchCartJson()
      .then(function (cart) {
        var totalCarrinho = cart.total_price / 100;
        var totalValueElement = document.getElementById("cart-total-value");
        if (totalValueElement) {
          totalValueElement.textContent = totalCarrinho.toLocaleString("pt-BR", {
            style: "currency",
            currency: "BRL",
          });
        }
      })
      .catch(function () {});
  };

  window.syncCupomUIFromCart = function (cart) {
    var appliedState = document.getElementById("cupom-applied-state");
    var inputContainer = document.getElementById("cupom-input-container");
    var errorState = document.getElementById("cupom-error-state");
    var appliedCode = document.getElementById("cupom-applied-code");
    var validationEl = document.getElementById("cupom-applied-validation");
    var codeInput = document.getElementById("minicart_billing_coupon");
    var errorMsg = document.getElementById("cupom-error-message");
    if (!appliedState || !inputContainer) return;

    inputContainer.classList.remove("show");
    inputContainer.classList.remove("has-error");

    if (errorState) {
      errorState.classList.remove("show");
      errorState.style.display = "none";
    }
    if (errorMsg) {
      var errorContainer = errorMsg.closest(".cupom-error-message-container");
      if (errorContainer) errorContainer.style.display = "none";
    }
    var hasApplicable =
      cart &&
      Array.isArray(cart.discount_codes) &&
      cart.discount_codes.some(function (dc) {
        return dc.applicable === true || dc.applicable === undefined;
      });
    if (hasApplicable) {
      var codigoAplicado = cart.discount_codes.find(function (dc) {
        return dc.applicable === true || dc.applicable === undefined;
      }).code;
      if (appliedCode) appliedCode.textContent = codigoAplicado.toUpperCase();
      if (validationEl) {
        if (cart.total_discount != null && cart.total_discount > 0) {
          var valorDesconto = (cart.total_discount / 100).toLocaleString(
            "pt-BR",
            {
              style: "currency",
              currency: "BRL",
            }
          );
          validationEl.textContent = "-" + valorDesconto;
        }
      }
      appliedState.style.display = "flex";
      inputContainer.style.display = "none";
    } else {
      if (validationEl) validationEl.textContent = "";
      appliedState.style.display = "none";
      inputContainer.style.display = "block";
    }
    if (codeInput) codeInput.value = "";
  };

  window.reRenderCartDrawerFromSection = function (cartData) {
    refreshCartDrawerFromSections()
      .then(function () {
        if (cartData) {
          syncCupomUIFromCart(cartData);
        } else {
          fetchCartJson().then(syncCupomUIFromCart).catch(function () {});
        }
        document.body.dispatchEvent(
          new CustomEvent("cart:refresh", {
            detail: { source: "cart-coupon" },
          })
        );
        refreshRegionalFreeShipping();
        restoreCartPromoLabels();
      })
      .catch(function (err) {
        console.error("Erro ao atualizar mini cart:", err);
        if (cartData) syncCupomUIFromCart(cartData);
      });
  };

  window.voltarEstadoInicialCupom = function (codigo) {
    var appliedState = document.getElementById("cupom-applied-state");
    var inputContainer = document.getElementById("cupom-input-container");
    var errorState = document.getElementById("cupom-error-state");
    var appliedCode = document.getElementById("cupom-applied-code");
    var errorMsg = document.getElementById("cupom-error-message");
    if (!inputContainer) return;

    inputContainer.classList.remove("show");
    inputContainer.classList.remove("has-error");

    if (errorState) {
      errorState.classList.remove("show");
      errorState.style.display = "none";
    }
    if (errorMsg) {
      var errorContainer = errorMsg.closest(".cupom-error-message-container");
      if (errorContainer) errorContainer.style.display = "none";
    }
    if (codigo && appliedState && appliedCode) {
      appliedCode.textContent = codigo.toUpperCase();
      appliedState.style.display = "flex";
      inputContainer.style.display = "none";
    } else {
      if (appliedState) appliedState.style.display = "none";
      inputContainer.style.display = "block";
    }

    var codeInput = document.getElementById("minicart_billing_coupon");
    if (codeInput) codeInput.value = "";
    atualizarTotaisCarrinho();
  };

  window.mostrarErroCupom = function (mensagem) {
    var appliedState = document.getElementById("cupom-applied-state");
    var inputContainer = document.getElementById("cupom-input-container");
    var errorState = document.getElementById("cupom-error-state");
    var errorMsg = document.getElementById("cupom-error-message");

    if (appliedState) appliedState.style.display = "none";

    if (errorState) {
      errorState.classList.remove("show");
      errorState.style.display = "none";
    }

    if (inputContainer) {
      inputContainer.classList.add("has-error");
      inputContainer.style.display = "block";
    }

    if (errorMsg) {
      errorMsg.textContent = mensagem || "Nao e um cupom valido :(";
      errorMsg.closest(".cupom-error-message-container").style.display = "block";
    }
  };

  window.retryCupom = function () {
    var inputContainer = document.getElementById("cupom-input-container");
    var errorState = document.getElementById("cupom-error-state");
    var couponInput = document.getElementById("minicart_billing_coupon");
    var errorInput = document.getElementById("minicart_billing_coupon_error");
    var errorMsg = document.getElementById("cupom-error-message");

    if (couponInput && errorInput) {
      couponInput.value = errorInput.value;
    }

    if (errorState) {
      errorState.classList.remove("show");
      errorState.style.display = "none";
    }

    if (inputContainer) {
      inputContainer.classList.remove("has-error");
      inputContainer.style.display = "block";
    }

    if (errorMsg) {
      errorMsg.closest(".cupom-error-message-container").style.display = "none";
    }

    if (couponInput) {
      couponInput.focus();
      couponInput.select();
    }
  };

  window.aplicarCupomMinicart = function () {
    var codeInput = document.getElementById("minicart_billing_coupon");
    var applyButton = document.querySelector(".cupom-apply-button");
    var applyButtonStatus = applyButton ? applyButton.querySelector(".cupom-apply-button__status") : null;
    var code = codeInput ? codeInput.value.trim() : "";

    function setApplyButtonState(isLoading) {
      if (!applyButton) return;

      applyButton.disabled = isLoading;
      applyButton.setAttribute("aria-busy", String(isLoading));
      applyButton.classList.toggle("is-loading", isLoading);

      if (applyButtonStatus) {
        applyButtonStatus.textContent = "aguarde...";
      }
    }

    var errorMsg = document.getElementById("cupom-error-message");
    var inputContainer = document.getElementById("cupom-input-container");

    if (inputContainer) inputContainer.classList.remove("has-error");
    if (errorMsg) {
      var errorContainer = errorMsg.closest(".cupom-error-message-container");
      if (errorContainer) errorContainer.style.display = "none";
    }

    if (!code) {
      mostrarErroCupom("Digite o codigo do cupom.");
      if (codeInput) codeInput.focus();
      return;
    }

    if (code.length < 2) {
      mostrarErroCupom("Codigo do cupom invalido.");
      if (codeInput) codeInput.focus();
      return;
    }

    setApplyButtonState(true);

    fetch("/cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ discount: code }),
    })
      .then(function (r) {
        return r.json().then(function (data) {
          return { ok: r.ok, status: r.status, data: data };
        });
      })
      .then(function (result) {
        var data = result.data;
        if (!result.ok) {
          var msg =
            (data && (data.description || data.message)) ||
            "Cupom invalido. Tente outro codigo.";
          setApplyButtonState(false);
          mostrarErroCupom(msg);
          return;
        }
        var cart = data;
        var applied =
          Array.isArray(cart.discount_codes) &&
          cart.discount_codes.some(function (dc) {
            return dc.applicable === true || dc.applicable === undefined;
          });
        if (applied) {
          reRenderCartDrawerFromSection(data);
        } else {
          setApplyButtonState(false);
          mostrarErroCupom(
            "Este cupom nao se aplica ao seu carrinho ou ja expirou."
          );
        }
      })
      .catch(function () {
        setApplyButtonState(false);
        mostrarErroCupom(
          "Erro ao aplicar cupom. Verifique sua conexao e tente novamente."
        );
      });
  };

  window.removerCupomMinicart = function () {
    var removeLink = document.getElementById("cupom-remove-link");

    if (removeLink && removeLink.classList.contains("is-loading")) return;

    if (removeLink) {
      removeLink.classList.add("is-loading");
      removeLink.setAttribute("aria-busy", "true");
    }

    fetch("/cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ discount: "" }),
    })
      .then(function (r) {
        return r.json().then(function (data) {
          return { ok: r.ok, data: data };
        });
      })
      .then(function (result) {
        reRenderCartDrawerFromSection(result.data);
      })
      .catch(function () {
        if (removeLink) {
          removeLink.classList.remove("is-loading");
          removeLink.setAttribute("aria-busy", "false");
        }
        voltarEstadoInicialCupom(null);
      });
  };

  window.inicializarCupomAplicado = function () {
    fetchCartJson()
      .then(syncCupomUIFromCart)
      .catch(function () {});
  };

  function initCartCoupon() {
    var viewport = document.querySelector(".layout--viewport");
    if (viewport) {
      var observer = new MutationObserver(function () {
        var isCartDrawerOpen =
          viewport.getAttribute("data-drawer-view") === "cart-drawer" &&
          viewport.getAttribute("data-drawer-status") === "opened";

        if (isCartDrawerOpen) {
          setTimeout(function () {
            inicializarCupomAplicado();
            restoreCartPromoLabels();
          }, 300);
        }
      });

      observer.observe(viewport, {
        attributes: true,
        attributeFilter: ["data-drawer-view", "data-drawer-status"],
      });

      if (
        viewport.getAttribute("data-drawer-view") === "cart-drawer" &&
        viewport.getAttribute("data-drawer-status") === "opened"
      ) {
        inicializarCupomAplicado();
      }
    }

    document.body.addEventListener("cart:refresh", function (event) {
      if (event.detail && event.detail.source === "cart-coupon") return;
      setTimeout(function () {
        inicializarCupomAplicado();
        restoreCartPromoLabels();
      }, 500);
    });

    document.body.addEventListener("theme:cart:updated", function () {
      setTimeout(restoreCartPromoLabels, 0);
    });
  }

  // Suporta carga adiada (após DOMContentLoaded) via deferred-scripts
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initCartCoupon);
  } else {
    initCartCoupon();
  }
})();
